
import { handleErrorApi } from "../../helpers/randoms";
import ComprasService from "../../services/ComprasService";
import { types } from "../../types/types";
import { ESTADOS_COTIZACIONES } from "../../utils/constants";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const SeleccionarOferente = (medico) =>{
    return{
        type:types.seleccionarOferente,
        payload: medico
    }
}

export const desSeleccionaOferente = () =>{
    return{
        type: types.desSeleccionarOferente,
    }
}

export const setEstadosSolicitudes = (estado) =>{
    debugger
    return{
        type: types.updateEstadosSolicitudesCotizacion,
        payload:estado
    }
}

export const setDatoNuevoDetalleCotizacion = (dato) =>{
    return{
        type: types.datoNuevoDetalleCotizacion,
        payload:dato
    }
}
export const desSeleccionarMaterial = ()=>{
    return{
        type: types.desSeleccionarMaterialCompras
    }
}
export const setMaterialCompras = (dato) =>{
    return{
        type: types.setMaterialCompras,
        payload: dato
    }
}
export const SeleccionarIdSolicitud = (id) =>{
    return{
        type:types.seleccionarIdSolicitud,
        payload: id
    }
}

export const SeleccionarFechaInicio = (fecha) =>{
    return{
        type:types.seleccionarFechaInicio,
        payload: fecha
    }
}

export const SeleccionarFechaFin = (fecha) =>{
    return{
        type:types.seleccionarFechaFin,
        payload: fecha
    }
}

export const SeleccionarFechaInicioAuditoria = (fecha) =>{
    return{
        type:types.seleccionarFechaInicioAuditoria,
        payload: fecha
    }
}

export const SeleccionarFechaFinAuditoria = (fecha) =>{
    return{
        type:types.seleccionarFechaFinAuditoria,
        payload: fecha
    }
}


export const TraerEstadosSolicitud = () => async (dispatch) =>{
    dispatch(startSpinner());
    try{
        const response = await ComprasService.traerEstadosSolicitud();
        const body= await response.json();
        if(response.ok){
            dispatch({
                type: types.estadosCotizacionesTraerSuccess,
                payload: body
            })
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.estadosCotizacionesTraerError})
        handleErrorApi(dispatch, error, "Error al traer los estados de la cotizacion","Ha ocurrido un error. Intente nuevamente")
    }
};

export const TraerListadoSolicitudes = (idAfiliado,idSolicitud, fechaInicio, fechaFin, idTipoSolicitud) => async (dispatch) =>{
    dispatch(startSpinner())
    try{
        const response = await ComprasService.traerSolicitudesCotizaciones(idAfiliado,idSolicitud,fechaInicio, fechaFin, idTipoSolicitud);
        const body = await  response.json();
        if(response.ok){
            dispatch({type: types.solicitudesCotizacionSuccess,
            payload:body
        })
        dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.solicitudesCotizacionError})
        handleErrorApi(dispatch, error, "Error al traer las solicitudes de cotizacion","Ha ocurrido un error. Intente nuevamente" )
    }
}

export const NuevaCotizacion = (idSolicitud, oferentes, materiales, observaciones, onSuccess) => async (dispatch) =>{
    dispatch(startSpinner())
    debugger
    const data = {
        IdSolicitud : idSolicitud, 
        Oferentes: oferentes, 
        Materiales1 : materiales?.map(mat => ({
            "IdMaterial": mat.idMaterial,
            "Cantidad":mat.cantidad,
            "IdEstadoMaterial": mat.idEstadoMaterial
        })),
        Observaciones: observaciones
    }
    try{
        const response = await ComprasService.NuevaCotizacion(data);
        const body = await response.json();
        if(response.ok){
            dispatch({
                type: types.nuevaCotizacionSuccess,
                payload: body
            })
            dispatch(startAlerta("Cotizacion Solicitada Correctamente", 'success', 'Comando Exitoso'))
            //dispatch(TraerListadoSolicitudes());
            dispatch(finishSpinner());
            if(onSuccess) onSuccess(); 
        }else{
            throw body;
        }
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.nuevaCotizacionError})
        handleErrorApi(dispatch, error, "Error al generar la cotizacion","Ha ocurrido un error. Intente nuevamente" )
    }
}


export const TraerCotizaciones = (idEstado, idAfiliado,idSolicitud,fechaInicio, fechaFin, idTipoSolicitud) => async (dispatch) =>{
    dispatch(startSpinner());
    try{
        debugger
        const response = await ComprasService.TraerCotizaciones(idEstado,idAfiliado,idSolicitud,fechaInicio,fechaFin,idTipoSolicitud);
        const body = await response.json(); 
        if(response.ok){
            dispatch({type: types.cotizacionesSucces,
            payload: body})
        }else{
            throw body; 
        }
        dispatch(finishSpinner());
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.cotizacionesError});
        handleErrorApi(dispatch, error, "Error al traer las cotizaciones","Ha ocurrido un error. Intente nuevamente" )
    }
}

export const editarDetalleCotizaciones = (detalles,idEstado,idTipoSolicitud) => async (dispatch,getState) =>{
    dispatch(startSpinner()); 
    try{
        const response = await ComprasService.EditarDetalleCotizaciones(detalles); 
        const body = await response.json(); 
        const { afiliadoSeleccionado } = getState().autorizaciones;
        const {fechaInicioCompras, fechaFinCompras,idSolicitudCompras} = getState().compras;
        if(response.ok){
            await dispatch(TraerCotizaciones(idEstado,afiliadoSeleccionado?.id_afiliado,idSolicitudCompras,fechaInicioCompras,fechaFinCompras,idTipoSolicitud));
            dispatch(finishSpinner());
            dispatch(startAlerta("Datos Modificados Correctamente", 'success', 'Comando Exitoso'))
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar los datos","Ha ocurrido un error. Intente nuevamente" )
    }
}

export const EliminarMaterialCotizacion =(idDetalleCotizacion, idEstado,idTipoSolicitud)=> async (dispatch,getState) => {
    dispatch(startSpinner());
    try{
        
        const response = await ComprasService.EliminarMaterialCotizacion(idDetalleCotizacion);
        const body = await response.json(); 
        //const { afiliadoSeleccionado } = getState().autorizaciones;
        if(response.ok){
            //await dispatch(TraerCotizaciones(idEstado, afiliadoSeleccionado?.id_afiliado,null,null,idTipoSolicitud));
            dispatch(startAlerta("Material Eliminado Correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al eliminar el material","Ha ocurrido un error. Intente nuevamente" )
    }
}

export const enviarCotizacion = (detalles,idEstado,idTipoSolicitud) => async (dispatch,getState) =>{
    dispatch(startSpinner());
    try{
        const response = await ComprasService.EnviarCotizacion(detalles); 
        const body = await response.json(); 
        const { afiliadoSeleccionado } = getState().autorizaciones;
        const {fechaInicioCompras, fechaFinCompras,idSolicitudCompras} = getState().compras;
        if(response.ok){
            dispatch(startAlerta("Cotizacion enviada correctamente", 'success', 'Comando Exitoso'));
            await dispatch(TraerCotizaciones(idEstado, afiliadoSeleccionado?.id_afiliado,idSolicitudCompras,fechaInicioCompras,fechaFinCompras,idTipoSolicitud))
            await dispatch(TraerContadoresCotizaciones(afiliadoSeleccionado?.id_afiliado,idSolicitudCompras,fechaInicioCompras,fechaFinCompras,idTipoSolicitud))
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al enviar la cotizacion","Ha ocurrido un error. Intente nuevamente" );
    }
}

export const aceptarCotizacion = (data,setEsproveedor, closeModal,idEstado,idTipoSolicitud) => async (dispatch,getState) =>{
    dispatch(startSpinner());
    try{
        const { afiliadoSeleccionado } = getState().autorizaciones;
        const {fechaInicioCompras, fechaFinCompras,idSolicitudCompras} = getState().compras;
        const response = await ComprasService.AceptarCotizacion(data); 
        const body= await response.json(); 
        debugger
        if(response.ok && body.length === 0){
            dispatch(startAlerta("Cotizacion aceptada", 'success', 'Comando Exitoso'));
            dispatch(TraerCotizaciones(idEstado,afiliadoSeleccionado?.id_afiliado,idSolicitudCompras,fechaInicioCompras,fechaFinCompras,idTipoSolicitud))
            dispatch(TraerContadoresCotizaciones(afiliadoSeleccionado?.id_afiliado, idSolicitudCompras,fechaInicioCompras,fechaFinCompras,idTipoSolicitud))
            dispatch(finishSpinner());
            if(closeModal) closeModal();
        }else{
            dispatch(startAlerta("No se pudo aceptar la cotizacion", 'error', 'Error'));
            dispatch(setDatoNuevoDetalleCotizacion(body));
            if(body.length > 0)
            {
                 setEsproveedor(true);
            }
            dispatch(finishSpinner());
        }

    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al aceptar la cotizacion","Ha ocurrido un error. Intente nuevamente" );
    }
}
export const enviarMailAceptacionCotizacion = (idSolicitud, idOferente) => async (dispatch) =>{
    dispatch(startSpinner());
    try{
        const response = await ComprasService.EnviarEmailAceptacionCotizacion(idSolicitud,idOferente); 
        const body= await response.json(); 
        if(response.ok){
            dispatch(startAlerta("Mails reenviados", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al aceptar la cotizacion","Ha ocurrido un error. Intente nuevamente" );
    }
}
export const enviarMailPedidoCotizacion = (idSolicitud, idOferente) => async (dispatch) =>{
    dispatch(startSpinner());
    try{
        const response = await ComprasService.EnviarEmailPedidoCotizacion(idSolicitud,idOferente); 
        const body= await response.json(); 
        if(response.ok){
            dispatch(startAlerta("Mail Reenviado Correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al aceptar la cotizacion","Ha ocurrido un error. Intente nuevamente" );
    }
}
export const TraerContadoresCotizaciones = (idAfiliado,idSolicitud,fechaInicio,fechaFin, idTipoSolicitud) => async (dispatch) =>{
    dispatch(startSpinner())
    try{
        debugger
        const response = await ComprasService.getContadoresCotizaciones(idAfiliado,idSolicitud,fechaInicio,fechaFin, idTipoSolicitud);
        const body = await  response.json();
        if(response.ok){
            dispatch({type: types.contadoresEstadosCotizacionesSuccess,
            payload:body
        })
        dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.contadoresEstadosCotizacionesError})
        handleErrorApi(dispatch, error, "Error al traer los contadores","Ha ocurrido un error. Intente nuevamente" )
    }
}

export const CambiarEstadoCotizacion = (idSolicitud,idTipoSolicitud) => async (dispatch,getState) =>{
    dispatch(startSpinner())
    try{
        const { afiliadoSeleccionado } = getState().autorizaciones;
        const {idSolicitudCompras, fechaInicioCompras,fechaFinCompras} = getState().compras;
        const response = await ComprasService.cambiarEstadoCotizacion(idSolicitud);
        const body = await  response.json();
        if(response.ok){
        dispatch(startAlerta(("Cotizacion devuelta", 'success', 'Comando Exitoso')))
        await dispatch(TraerCotizaciones(ESTADOS_COTIZACIONES.COTIZACIONES_SOLICITADAS,afiliadoSeleccionado?.id_afiliado,idSolicitudCompras,fechaInicioCompras,fechaFinCompras,idTipoSolicitud)); 
        await dispatch(TraerContadoresCotizaciones(afiliadoSeleccionado?.id_afiliado,idSolicitudCompras,fechaInicioCompras,fechaFinCompras,idTipoSolicitud))
        dispatch(finishSpinner());
    }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "No se pudo devolver la cotizacion a solicitadas.","Ha ocurrido un error. Intente nuevamente" )
    }
}
export const enviarMailIncorporacionOferente = (idSolicitud, idOferente) => async (dispatch) =>{
    dispatch(startSpinner());
    try{
        const response = await ComprasService.EnviarEmailIncorporacionOferente(idSolicitud,idOferente); 
        const body= await response.json(); 
        if(response.ok){
            dispatch(startAlerta("Se envió el mail para que incorporen al/los oferente/s.", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al enviar mail de aviso.","Ha ocurrido un error. Intente nuevamente" );
    }
}

export const NuevaCotizacionExpress = (idSolicitud, idEfectorFacturacion, materiales) => async (dispatch) =>{
    dispatch(startSpinner())
    const data = {
        IdSolicitud : idSolicitud, 
        idEfectorFacturacion: idEfectorFacturacion, 
        Materiales1 : materiales
    }
    try{
        const response = await ComprasService.NuevaCotizacionExpress(data);
        const body = await response.json();
        if(response.ok){
            dispatch(startAlerta("Cotizacion Cargada Correctamente", 'success', 'Comando Exitoso'))
            //dispatch(TraerListadoSolicitudes());
            dispatch(finishSpinner());
        }else{
            throw body;
        }
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.nuevaCotizacionError})
        handleErrorApi(dispatch, error, "Error al generar la cotizacion","Ha ocurrido un error. Intente nuevamente" )
    }

}

export const NuevoOferenteEnCotizacionCarga = (idCotizacion, oferentes,idEstado,idTipoSolicitud) => async (dispatch,getState) =>{
    dispatch(startSpinner())
    const data = {
        IdCotizacion : idCotizacion, 
        Oferentes: oferentes
    }
    try{
        const { afiliadoSeleccionado } = getState().autorizaciones;
        const {idSolicitudCompras,fechaInicioCompras,fechaFinCompras} = getState().compras;
        const response = await ComprasService.agregarOferenteCotizacionCargada(data);
        const body = await response.json();
        if(response.ok){
            dispatch(startAlerta("Cotizacion Cargada Correctamente", 'success', 'Comando Exitoso'))
            //dispatch(TraerListadoSolicitudes());
            dispatch(TraerCotizaciones(idEstado,afiliadoSeleccionado?.id_afiliado,idSolicitudCompras,fechaInicioCompras,fechaFinCompras,idTipoSolicitud))
            dispatch(finishSpinner());
        }else{
            throw body;
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al generar la cotizacion","Ha ocurrido un error. Intente nuevamente" )
    }

}

export const TraerSolicitudTerminada = (idSolicitud,setSolicitudSeleccionada) => async (dispatch) =>{
    dispatch(startSpinner())
    try{
        debugger
        const response = await ComprasService.TraerSolicitudTerminada(idSolicitud);
        const body = await  response.json();
        if(response.ok){
        setSolicitudSeleccionada(body);
        dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.solicitudesCotizacionError})
        handleErrorApi(dispatch, error, "Error al traer la solicitud","Ha ocurrido un error. Intente nuevamente" )
    }
}

export const AnularSolicitud = (idCotizacion, motivoBaja,idTipoSolicitud,closeModal) => async (dispatch,getState) =>{
    dispatch(startSpinner())
    const data = {
        idCotizacion: idCotizacion,
        motivoBaja: motivoBaja
    }
    try{
        debugger
        const { afiliadoSeleccionado } = getState().autorizaciones;
        const {estadosSolicitud,idSolicitudCompras,fechaInicioCompras,fechaFinCompras} = getState().compras;
        const response = await ComprasService.AnularSolicitud(data);
        const body = await response.json();
        if(response.ok){
            dispatch(startAlerta("Cotizacion Anulada Correctamente", 'success', 'Comando Exitoso'))
            dispatch(TraerCotizaciones(estadosSolicitud,afiliadoSeleccionado?.id_afiliado,idSolicitudCompras,fechaInicioCompras,fechaFinCompras,idTipoSolicitud))
            if(closeModal) closeModal();
        }else{
            throw body;
        }
        dispatch(finishSpinner());
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.nuevaCotizacionError})
        handleErrorApi(dispatch, error, "Error al generar la cotizacion","Ha ocurrido un error. Intente nuevamente" )
    }

}